import { Chips } from '@tcweb/connect-ui';
import { t } from '@trimble/i18n';
import { createMemo, JSX } from 'solid-js';

export interface TagsProps {
  tags: string[];
}

export const Tags = (props: TagsProps): JSX.Element => {
  const tagsLabel = createMemo((): string => {
    const label = t('shared.ui.tags.tags');
    const tags = props.tags;

    if (tags.length === 0) return label;

    return `${label} (${tags.length.toString()})`;
  });

  return (
    <div class="flex flex-col">
      <div class="h5 p-3 pb-0">{tagsLabel()}</div>
      <div class="p-3">
        <Chips chips={props.tags} />
      </div>
    </div>
  );
};
